import axios from 'axios'
//
// initial state
const state = {
  activeDelivery: 1,
  delivery: {},
  rotChecked: false,
  status: {
    loading: false,
    error: false,
    success: false
  },
  svea: {},
}

const getters = {
  store: (state) => {
    return state?.delivery?.Stores
      ? state.delivery.Stores[0]
      : null
  }
}

// actions
const actions = {
  // Get checkout
  getCheckout ({ commit, dispatch }, { api }) {
    commit('setStatus', { loading: true })
    commit('setStatus', { success: false })
    commit('setStatus', { error: false })

    axios.get(api).then(response => {
        const data = !!response && response?.data?.Data
          ? response.data.Data
          : null

        const cart = !!data && data?.Cart
          ? data.Cart
          : null

        // only for debugging
        if (data.DebugConsoleValues) {
          dispatch('debugConsole/setDebugState', data?.DebugConsoleValues, { root: true })
        }

        // console.log('GET CHECKOUT API RESPONSE:', data)

        dispatch('setCheckoutState', data)
        dispatch('cart/setCartState', cart, { root: true })
      })
      .catch(error => {
        // console.log('GET CHECKOUT ERROR:', error)
        commit('setStatus', { success: false })
        commit('setStatus', { error: true })
      })
      .finally(() => commit('setStatus', { loading: false }))
  },
  // Set checkout
  setCheckout ({ commit, dispatch }, { api, params }) {
    commit('setStatus', { loading: true })
    commit('setStatus', { success: false })
    commit('setStatus', { error: false })

    axios.post(api, params).then(response => {
        const data = !!response && response?.data?.Data
          ? response.data.Data
          : null

        const cart = !!data && data?.Cart
          ? data.Cart
          : null

        // only for debugging
        if (data.DebugConsoleValues) {
          dispatch('debugConsole/setDebugState', data?.DebugConsoleValues, { root: true })
        }

        // console.log('SET CHECKOUT API RESPONSE:', data)
        dispatch('setCheckoutState', data)
        dispatch('cart/setCartState', cart, { root: true })
      })
      .catch(error => {
        // console.log('SET CHECKOUT ERROR:', error)
        commit('setStatus', { success: false })
        commit('setStatus', { error: true })
      })
      .finally(() => commit('setStatus', { loading: false }))
  },
  // Set checkout state
  setCheckoutState ({ commit }, data) {
    const rotChecked = !!data && data?.RotChecked
    ? data.RotChecked
    : false

    const delivery = !!data && data?.Delivery
    ? data.Delivery
    : null

    const activeDeliveryOption = !!data && data?.Delivery?.Options
      ? data.Delivery.Options.find(item => {
          if (item.Checked) return item
        })
      : 1

    const svea = !!data && data?.Svea
    ? data.Svea
    : null


    commit('setRotChecked', rotChecked)
    commit('setActiveDelivery', activeDeliveryOption)
    commit('setDelivery', delivery)
    commit('setSvea', svea)
    commit('setStatus', { success: true })
  }

}

// mutations
const mutations = {
  setActiveDelivery (state, activeItem) {
    if (typeof activeItem === 'object' && activeItem !== null) {
      state.activeDelivery = activeItem?.Type ? activeItem.Type : 1
    } else {
      state.activeDelivery = activeItem ? activeItem : 1
    }
  },

  setDelivery (state, data) {
    state.delivery = !data ? {} : data
  },

  setRotChecked (state, data) {
    state.rotChecked = !data ? false : data
  },

  setSvea (state, data) {
    state.svea = !data ? {} : data
  },

  setStatus (state, statusObj) {
    const key = Object.keys(statusObj)[0]
    const value = Object.values(statusObj)[0]
    state.status[key] = value
  },
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
